var map = {
	"./I Miss The Misery Reel Cover.jpg": 1879,
	"./collision_video_photo.jpg": 2762,
	"./fist-sticks.jpg": 3627,
	"./playing.jpg": 1913,
	"./sticks-at-front.jpg": 470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9171;